import { FARM_PRODUCT_GROUPS } from "../constants/ProductConstant";

export const checkOrderStockAvailability = (order, products, crateStocks) => {
  if (!order?.userShoppingCart || !Array.isArray(order.userShoppingCart)) {
    return { available: true, missingProducts: [] };
  }

  const missingProducts = [];
  const crateStockMap = buildCrateStockMap(crateStocks);

  for (const cartItem of order.userShoppingCart) {
    const product = products.find((p) => p.id === cartItem.productId || p.productId === cartItem.productId);

    if (!product) continue;

    const productGroup = product.productGroup;

    if (productGroup === "Bundles") {
      const requiredBundleQty = cartItem.itemCount || 0;
      const availableBundleQty = crateStockMap[cartItem.productId] || 0;

      // Check if bundles themselves are available in crates
      if (availableBundleQty >= requiredBundleQty) {
        // Bundles are available, no need to check underlying products
        continue;
      }

      // If some bundles are available but not enough, show that first
      if (availableBundleQty > 0 && availableBundleQty < requiredBundleQty) {
        missingProducts.push({
          productId: cartItem.productId,
          productName: product.productName,
          required: requiredBundleQty,
          available: availableBundleQty,
          missing: requiredBundleQty - availableBundleQty,
          isBundle: false,
          isBundleItself: true,
          bundleName: product.productName,
        });
      }

      // Bundles not available (or not enough), check underlying products
      const bundleItems = cartItem.bundleItems || [];
      const missingBundleQty = requiredBundleQty - availableBundleQty;

      for (const bundleItem of bundleItems) {
        const bundleProduct = products.find(
          (p) => p.id === bundleItem.productId || p.productId === bundleItem.productId,
        );
        if (!bundleProduct) continue;

        if (FARM_PRODUCT_GROUPS.includes(bundleProduct.productGroup)) {
          const itemCountPerBundle = bundleItem.itemCount || bundleItem.quantity || 0;
          // Only calculate required qty for the missing bundles
          const requiredQty = itemCountPerBundle * missingBundleQty;
          const availableQty = crateStockMap[bundleItem.productId] || 0;

          if (availableQty < requiredQty) {
            missingProducts.push({
              productId: bundleItem.productId,
              productName: bundleProduct.productName,
              required: requiredQty,
              available: availableQty,
              missing: requiredQty - availableQty,
              isBundle: true,
              isBundleItself: false,
              bundleName: product.productName,
              missingBundleQty: missingBundleQty,
            });
          }
        }
      }
    } else if (FARM_PRODUCT_GROUPS.includes(productGroup)) {
      const requiredQty = cartItem.itemCount || 0;
      const availableQty = crateStockMap[cartItem.productId] || 0;

      if (availableQty < requiredQty) {
        missingProducts.push({
          productId: cartItem.productId,
          productName: product.productName,
          required: requiredQty,
          available: availableQty,
          missing: requiredQty - availableQty,
          isBundle: false,
        });
      }
    }
  }

  return {
    available: missingProducts.length === 0,
    missingProducts,
  };
};

const buildCrateStockMap = (crateStocks) => {
  const stockMap = {};

  if (!Array.isArray(crateStocks)) return stockMap;

  for (const crate of crateStocks) {
    if (crate.status !== "in_use" || !Array.isArray(crate.items)) continue;

    for (const item of crate.items) {
      const productId = item.productId;
      const quantity = Number(item.quantity || 0);

      if (productId && quantity > 0) {
        stockMap[productId] = (stockMap[productId] || 0) + quantity;
      }
    }
  }

  return stockMap;
};
